// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button_Button_1PG6I","Success":"Button_Success_30rYK","Danger":"Button_Danger_1T9Z5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Ui/Button/Button.css
// module id = 115
// module chunks = 3